import React, { useEffect } from "react";
import "./Experience.css";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

function Experience() {

  useEffect(() => {
    const valueDisplays = document.querySelectorAll(".nums");
    
    const startCounter = (valueDisplay) => {
      let startValue = 0;
      const endValue = parseInt(valueDisplay.getAttribute("data-val"));
      const duration = Math.floor(1000 / endValue);
      const counter = setInterval(() => {
        startValue += 1;
        valueDisplay.textContent = startValue;
        if (startValue === endValue) {
          clearInterval(counter);
        }
      }, duration);
    };
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const valueDisplays = entry.target.querySelectorAll(".nums");
            valueDisplays.forEach((valueDisplay) => {
              startCounter(valueDisplay);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 } 
    );

    const experienceSection = document.querySelector(".experience");
    observer.observe(experienceSection);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="experience">
      <div className="experience-image">
        <h1>Build<span> Angles</span></h1>
        <h2>It's Your Dream We Build</h2>
        <h4><FaMapMarkerAlt className='icen' /> No 161, Meethotamulla, Dematagoda</h4>
        <h4><FaPhone className='icen' /> 074 394 6545 | 074 394 6544 | 077 789 5606</h4>
        <h4><FaEnvelope className='icen' /> baengineerings@gmail.com</h4>
      </div>
      <div className="achievement">
        <div className="circle"><span className="nums" data-val="8">0</span>+</div>
        <span className="desript">years </span>
        <span className="desript">Experience</span>
      </div>
      <div className="achievement">
        <div className="circle"><span className="nums" data-val="42">0</span>+</div>
        <span className="desript">Total </span>
        <span className="desript">Projects</span>
      </div>
      <div className="achievement">
        <div className="circle"><span className="nums" data-val="8">0</span>+</div>
        <span className="desript">Ongoing </span>
        <span className="desript">Projects</span>
      </div>
      <div className="achievement">
        <div className="circle"><span className="nums" data-val="35">0</span>+</div>
        <span className="desript">Completed </span>
        <span className="desript">Projects</span>
      </div>
    </div>
  );
};

export default Experience;
